import { defineComponent as _defineComponent } from 'vue'
import DictionaryService from '@/core/dictionary.service';
import { store } from '@/store';
import ServerContextService from '@/core/server-context.service';
import CookieService from '@/core/cookie.service';
import QueryParamsService, { QueryParams } from '@/core/query-params.service';
import { computed, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DualLanguagePrompt',
  setup(__props) {

const cookieName = 'lp-lang';

const selectedMode = computed<IMode>(() => store.getters['app/selectedMode']);

const modalOpen = ref<boolean>(false);
const headlineText = ref<string>('');
const currentLanguageName = ref<string>('');
const alternateLanguageName = ref<string>('');

let data : AlternateMarketViewModel;

onMounted(() => {
    data = ServerContextService.alternateMarketData;

    checkForCookieSignal();

    if (data.isActive) {
        modalOpen.value = !hasCookieForCurrentMarket();
        headlineText.value = DictionaryService.get('Pages.DualLanguagePrompt.Headline');
        currentLanguageName.value = data.currentLanguageName;
        alternateLanguageName.value = data.alternateLanguageName;
    }
});

function checkForCookieSignal() {
    // check if we received a singal querystring to update the language cookie
    const updateCookie = QueryParamsService.hasParam(QueryParams.DualLanguageSignal);

    if (updateCookie) {
        QueryParamsService.deleteQueryParam(QueryParams.DualLanguageSignal);
        setCookie(data.currentMarketId);
    }
}

function setCookie(marketId: string) {
    const cookieObject = {};
    cookieObject[data.countryCode] = marketId;
    CookieService.set(cookieName, JSON.stringify(cookieObject));
}

function hasCookieForCurrentMarket() {
    const cookieValue = CookieService.get(cookieName);
    if (cookieValue) {
        const cookieObject = JSON.parse(cookieValue);
        const value = cookieObject[data.countryCode];
        return value === data.currentMarketId;
    }
    return false;
}

function doHardRedirect() {
    window.location.href = `/${data.alternateMarketId}/${selectedMode.value.name}?${QueryParams.DualLanguageSignal}`;
}

function closeModalRemainOnMarket() {
    setCookie(data.currentMarketId);
    modalOpen.value = false;
}

return { __sfc: true,cookieName, selectedMode, modalOpen, headlineText, currentLanguageName, alternateLanguageName, data, checkForCookieSignal, setCookie, hasCookieForCurrentMarket, doHardRedirect, closeModalRemainOnMarket }
}

})